import { render, staticRenderFns } from "./IkkatsuCorrectImageUpload.vue?vue&type=template&id=51b63c7c&"
import script from "./IkkatsuCorrectImageUpload.vue?vue&type=script&lang=ts&"
export * from "./IkkatsuCorrectImageUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports